import { AxiosResponse } from 'axios';

import { $httpRootApi } from '@core/http-client';

export const agreementsMutations = {
  accept: async (_payload: undefined) =>
    await $httpRootApi.post<undefined, AxiosResponse<undefined>>('/agreements/accept'),
};
